import request from '@/utils/request'

// private Integer userChatTitleId;
// private Integer chatType;
//
export function getList(data) {
  return request({
    url: '/user/user/user/userChatContent/list',
    method: 'post',
    data
  })
}



export function getImageList(data) {
  return request({
    url: '/user/user/user/userChatContent/getImageList',
    method: 'post',
    data
  })
}



export function getVersionLogsList() {
  return request({
    url: '/user/user/user/userChatContent/getVersionLogsList',
    method: 'post'

  })
}

export function checkVersionLogs() {
  return request({
    url: '/user/user/user/userChatContent/checkVersionLogs',
    method: 'post'

  })
}



// 消息文本
// private String message;

// //标题内容ID
// private Integer userChatTitleId;

// // 消息类型
// private Integer messageType;

// // 引导详情编号
// private Integer aiChatTypeDetailId;

// // 详细提交数据
// private String subText;
export function add(data) {
  return request({
    url: '/user/user/user/userChatContent/add',
    method: 'post',
    data
  })
}

export function agreementKnow(data) {
  return request({
    url: '/user/user/user/userChatContent/addUserAgreement',
    method: 'post',
    data
  })
}



export function remove(params) {
  return request({
    url: '/user/user/user/userChatContent/delete',
    method: 'get',
    params
  })
}
export function removeAll(data) {
  return request({
    url: '/user/user/user/userChatContent/clean',
    method: 'post',
    data
  })
}


// 删除票提PC
export function cleanTitlePC(data) {
  return request({
    url: '/user/user/user/userChatTitle/cleanTitle',
    method: 'post',
    data
  })
}



// 获取消息通知
export function getCompanyInvite() {
  return request({
    url: '/user/user/userUser/getCompanyInvite',
    method: 'post'

  })
}

export function companyInviteReply(data) {
  return request({
    url: '/user/user/userUser/companyInviteReply',
    method: 'post',
    data

  })
}



export function show(params) {
  return request({
    url: '/user/user/user/userChatContent/show',
    method: 'get',
    params
  })
}
// 获取所有工具列表
export function getAllart(data) {
  return request({
    url: '/user/user/user/userChatContent/list',
    method: 'post',
    data
  })
}

export function getModelTypeList(data) {
  return request({
    url: '/user/user/user/userChatContent/getModelTypeList',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/user/userChatContent.js